import { Box, Theme, Typography } from "@outschool/backpack";
import { TFunction } from "@outschool/localization";
import { useTrackEvent } from "@outschool/ui-analytics";
import {
  ToggleButton,
  TrackingPageSection
} from "@outschool/ui-legacy-component-library";
import React from "react";

import { CategoryTutoringFiltersProps } from "./HeroFilters";

const FREQUENCY_FILTERS: Array<{ min: number; max: number }> = [
  { min: 1, max: 1 },
  { min: 2, max: 3 },
  { min: 4, max: 5 }
];

function frequencyString(frequency: number, t: TFunction) {
  switch (frequency) {
    case 1:
      return t("1 time per week");
    case 2:
      return t("2-3 times per week");
    case 4:
      return t("4-5 times per week");
    default:
      return t("");
  }
}

const TutoringCLPFrequencyFilter: React.FC<CategoryTutoringFiltersProps> = ({
  categorySlug,
  updateListings,
  label,
  t,
  searchFilters
}) => {
  const trackEvent = useTrackEvent();
  return (
    <TrackingPageSection
      name="category_freq_filters"
      uniqueId={"radio_buttons"}
    >
      {setImpressionNode => (
        <Box
          flex
          sx={{
            flexWrap: "wrap",
            gap: "10px"
          }}
          ref={setImpressionNode}
        >
          <Typography
            variant="h4"
            emphasized
            sx={(theme: Theme) => ({
              width: "100%",
              padding: "12px",
              [theme.breakpoints.up("md")]: {
                borderBottom: "1px solid",
                borderColor: theme.palette.grey[300]
              },
              [theme.breakpoints.down("md")]: {
                textAlign: "center"
              }
            })}
          >
            {label}
          </Typography>
          <Box
            flex
            sx={{
              gap: "12px",
              justifyContent: "center",
              width: "100%"
            }}
          >
            {FREQUENCY_FILTERS.map(frequency => {
              const enabled = searchFilters.weeklyMeetingsMin === frequency.min;
              return (
                <ToggleButton
                  key={frequency.min}
                  enabled={searchFilters.weeklyMeetingsMin === frequency.min}
                  onClick={() => {
                    updateListings({ min: frequency.min, max: frequency.max });
                    trackEvent("category_filter_click", {
                      categorySlug,
                      searchFilters: { min: frequency.min, max: frequency.max }
                    });
                  }}
                  sx={{
                    marginRight: "tiny",
                    padding: "0.9rem",
                    height: "83px",
                    width: "113px",
                    color: enabled ? "white" : "primary",
                    borderColor: "primary",
                    borderWidth: "2px",
                    textWrap: "wrap",
                    borderRadius: "15px"
                  }}
                  value={frequency.min}
                >
                  {frequencyString(frequency.min, t)}
                  {frequency.min === 2 && (
                    <Typography variant={"caption"}>
                      {t(" (recommended)")}
                    </Typography>
                  )}
                </ToggleButton>
              );
            })}
          </Box>
        </Box>
      )}
    </TrackingPageSection>
  );
};

export default TutoringCLPFrequencyFilter;
